import { HTTP } from "./http-common";

const contactAPI = {
  updateContacts(contacts) {
    console.log("[API updateContacts] contacts:", contacts);

    return HTTP.put(`/contact`, {
      contacts,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CC1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
};

export default contactAPI;



// WEBPACK FOOTER //
// ./src/api/contact.js